// Duck Crossing — hop across the road and river to the goal.
export function createFrogger(host) {
  const { ctx, input } = host; const W = host.W, H = host.H;
  const ROWS = 13, rh = H / ROWS, cw = 44;
  let lanes = [];
  const build = () => {
    lanes = [];
    for (let r = 0; r < ROWS; r++) {
      if (r === ROWS - 1 || r === 0 || r === 7) lanes.push({ type: 0 });
      else if (r > 7) { const dir = r % 2 ? 1 : -1; lanes.push({ type: 1, dir, speed: 55 + Math.random() * 70, items: [0, 180, 360].map((x) => x + Math.random() * 80), len: cw, color: "#f87171" }); }
      else { const dir = r % 2 ? 1 : -1; lanes.push({ type: 2, dir, speed: 40 + Math.random() * 55, items: [0, 210, 420].map((x) => x + Math.random() * 60), len: 96, color: "#a16207" }); }
    }
  };
  build();
  let cx = W / 2, cr = ROWS - 1;
  const reset = () => { cx = W / 2; cr = ROWS - 1; };
  return {
    dim: "2d", w: W, h: H, controls: ["left", "right", "up", "down"], score: 0, over: false,
    frame(dt) {
      for (const a of input.taps) { if (a === "up" && cr > 0) cr--; if (a === "down" && cr < ROWS - 1) cr++; if (a === "left") cx -= cw; if (a === "right") cx += cw; }
      cx = Math.max(cw / 2, Math.min(W - cw / 2, cx));
      lanes.forEach((l) => { if (l.type === 0) return; l.items = l.items.map((x) => { x += l.dir * l.speed * dt; if (l.dir > 0 && x > W + l.len) x = -l.len; if (l.dir < 0 && x < -l.len) x = W + l.len; return x; }); });
      const lane = lanes[cr], cy = cr * rh + rh / 2;
      if (lane.type === 1) { for (const x of lane.items) if (Math.abs((x + lane.len / 2) - cx) < lane.len / 2 + 15) { this.over = true; host.sfx.hit?.(); } }
      else if (lane.type === 2) { let on = false; for (const x of lane.items) if (cx > x && cx < x + lane.len) { on = true; cx += lane.dir * lane.speed * dt; } if (!on) { this.over = true; host.sfx.hit?.(); } cx = Math.max(cw / 2, Math.min(W - cw / 2, cx)); }
      if (cr === 0) { this.score += 50; host.sfx.win?.(); reset(); }
      for (let r = 0; r < ROWS; r++) { const l = lanes[r]; ctx.fillStyle = l.type === 0 ? "#166534" : l.type === 1 ? "#1f2937" : "#0c4a6e"; ctx.fillRect(0, r * rh, W, rh); }
      lanes.forEach((l, r) => { if (l.type === 0) return; ctx.fillStyle = l.color; l.items.forEach((x) => ctx.fillRect(x, r * rh + 6, l.len, rh - 12)); });
      ctx.fillStyle = "#fde68a"; ctx.fillRect(0, 0, W, rh); ctx.fillStyle = "#065f46"; ctx.font = "bold 13px monospace"; ctx.fillText("\u2691 GOAL", 8, rh - 7);
      ctx.fillStyle = "#fbbf24"; ctx.beginPath(); ctx.arc(cx, cy, 14, 0, 7); ctx.fill(); ctx.fillStyle = "#f97316"; ctx.fillRect(cx + 10, cy - 2, 7, 5); ctx.fillStyle = "#000"; ctx.beginPath(); ctx.arc(cx + 4, cy - 4, 2, 0, 7); ctx.fill();
    },
  };
}
